export const environment = {
  production: true,
  webSocketApi: 'ws://www.credit100.com/webSocket/socketRegister'
};



// WEBPACK FOOTER //
// E:/java/gd-project/credit-gd-web/src/environments/environment.ts